'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNotes(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M2.796 10.607h6.122c.44 0 .796.384.796.857 0 .437-.303.798-.696.85l-.1.007H2.796c-.44 0-.796-.383-.796-.857 0-.437.304-.797.696-.85l.1-.007zm.043-3.428H13.16c.463 0 .839.383.839.857 0 .437-.32.797-.734.85l-.105.007H2.84A.848.848 0 012 8.036c0-.437.32-.798.734-.85l.105-.007H13.16 2.84zm0-3.429H13.16c.463 0 .839.384.839.857 0 .437-.32.798-.734.85l-.105.007H2.84A.848.848 0 012 4.607c0-.437.32-.797.734-.85l.105-.007z", fill: "currentColor" }))));
}

module.exports = SvgNotes;
//# sourceMappingURL=Notes.js.map
